module.exports = __webpack_public_path__ + "img/NWTULogoTransparent300x291.9be4750a.png";